import BottomText from './BottomText';
import FooterWrapper from './FooterWrapper';

export { BottomText, FooterWrapper };
